// removed by extract-text-webpack-plugin
module.exports = {"spacer":"MeetingParticipantSummary-spacer","summaryTitle":"MeetingParticipantSummary-summaryTitle","participantSummary":"MeetingParticipantSummary-participantSummary"};